import React from "react";
import styled, { keyframes } from "styled-components";
import ArticlePhotoST from "./ArticlePhoto";
import ArticleDescST from "./ArticleDesc";
import Helmet from "react-helmet";
import { useLocation } from "@reach/router";
import ArticleBlogsST from "./ArticleBlogs";

const radioWave = keyframes`
  0% {
    transform: scale(0.5);
    opacity: 1;
  }
  90% {
    transform: scale(1.5);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
`;
const beatingHeart = keyframes`
  0%, 20%, 50%, 80%, 100% {
    transform: scale(1);
  }
  40% {
    transform: scale(1.3);
  }
  60% {
    transform: scale(1.1);
  }
`;

const Prod = styled.div`
position: relative;
display: flex;
align-items: flex-start;
/* overflow-y: auto;
overflow-x: hidden;
height: 100vh; */
&>.image-gallery{
    width: 98%;
    margin-top: 0;
    @media screen and (max-width: 786px) {
        width: 100%;
    }
}

@media screen and (max-width: 786px) {
    flex-direction: column;
    align-items: center;
}
`;
export default function ArticleST({data}) {
  const location = useLocation();
  return (
  
   <div>
    {/* <Helmet>
    <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Product",
          brand: {
            "@context": "http://schema.org",
            "@type": "Brand",
            name: "Self Tissus",
          },
          name: data?.Article?.Meta?.Meta?.Titre,
          offers: {
            "@type": "Offer",
            priceCurrency: "EUR",
            priceValidUntil: data?.Article?.Meta?.Meta?.TarifExpiration,
            price: data?.Article?.Prix || "default_price",
            availability: "https://schema.org/InStock",
          },
          category: data?.Article?.Meta?.Meta?.Categorie,
          aggregateRating: {
            "@type": "AggregateRating",
            ratingValue: data?.Article?.Meta?.Meta?.RatingValue,
            bestRating: data?.Article?.Meta?.Meta?.BestRating,
            ratingCount: data?.Article?.Meta?.Meta?.RatingCountp,
          },
          image: [data?.Article?.Meta?.Meta?.URLImage],
          description: data?.Article?.Meta?.Meta?.Description,
          sku: data?.Article?.Meta?.Meta?.CodeSKU,
          url: "https://www.selftissus.fr/" + location.pathname,
        })}
      </script>
</Helmet> */}
    <Prod>
        <ArticlePhotoST className="img" data={data?.Produit?.Articles} dataProd={data?.Article}/>
        <ArticleDescST className="desc" data={data?.Article}/>
    </Prod>
    {/* <ArticleBlogsST/> */}
   </div>
    
  );
}

